import { connectListView, ListView } from "../../../UI/view/list-view";
import { liquidBillingDeliveryDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingDeliveryList = {
  name: 'liquidBillingDeliveryList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns,
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingDeliveryList'),
} as ListView;

export const [LiquidBillingDeliveryList, LiquidBillingInvoiceDeliveryDataSource] = connectListView(liquidBillingDeliveryList, liquidBillingDeliveryDS);